import { translate } from "app/filters/i18nFilter";
import CardHeader from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/CardHeader/CardHeader";
import { CardErrorBoundary } from "app/pages/sales-intelligence/pages/company-analysis/components/shared/CardErrorBoundary/CardErrorBoundary";
import { EmptyState } from "app/pages/sales-intelligence/pages/company-analysis/containers/overview/GeoBreakdown/EmptyState";
import { GeoBreakdown } from "app/pages/sales-intelligence/pages/company-analysis/containers/overview/GeoBreakdown/GeoBreakdown";

export const GeoBreakdownWithErrorBoundary = () => (
    <CardErrorBoundary
        dataAutomation="geo-breakdown-card"
        header={
            <CardHeader
                title={translate("si.company-analysis.geo-breakdown.card.title")}
                infoTooltip={translate("si.company-analysis.geo-breakdown.card.tooltip")}
            />
        }
        fallbackContent={<EmptyState />}
    >
        <GeoBreakdown />
    </CardErrorBoundary>
);
